import axios, { AxiosInstance, InternalAxiosRequestConfig, AxiosResponse } from 'axios';
import { useAuthStore } from '../store/authStore';
import { LoggerService } from './LoggerService';

// Create axios instance - use relative URL for production (goes through nginx proxy)
const api: AxiosInstance = axios.create({
  baseURL: '/api/v1',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor to add auth token
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    LoggerService.debug('API request', { method: config.method?.toUpperCase(), url: config.url });
    const token = useAuthStore.getState().accessToken;
    if (token && config.headers) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Add cache-busting parameter for GET requests
    if (config.method === 'get' && config.url) {
      const separator = config.url.includes('?') ? '&' : '?';
      config.url = `${config.url}${separator}_t=${Date.now()}`;
    }

    return config;
  },
  (error) => {
    LoggerService.error('API request error', { message: error.message });
    return Promise.reject(error);
  }
);

// Response interceptor to handle errors
api.interceptors.response.use(
  (response: AxiosResponse) => {
    LoggerService.debug('API response', { status: response.status, url: response.config.url });
    return response;
  },
  (error) => {
    LoggerService.error('API response error', {
      status: error.response?.status,
      url: error.config?.url,
      message: error.message,
    });
    if (error.response?.status === 401) {
      try {
        useAuthStore.getState().logout();
        window.location.href = '/login';
      } catch (logoutError) {
        LoggerService.error('Error during logout', { message: (logoutError as Error).message });
      }
    }
    return Promise.reject(error);
  }
);

export default api;
